"use client";

import { useEffect, useRef } from "react";

interface Drop {
  x: number;
  y: number;
  len: number;
  speed: number;
  alpha: number;
}

export default function NavbarRain({ active }: { active: boolean }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !active) return;

    canvas.width = canvas.offsetWidth || window.innerWidth;
    canvas.height = canvas.offsetHeight || 64;

    const W = canvas.width;
    const H = canvas.height;
    const ctx = canvas.getContext("2d")!;

    const drops: Drop[] = Array.from({ length: 80 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H * 2 - H,
      len: 5 + Math.random() * 10,
      speed: 3 + Math.random() * 5,
      alpha: 0.15 + Math.random() * 0.5,
    }));

    let rafId: number;

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      drops.forEach((d) => {
        ctx.beginPath();
        ctx.moveTo(d.x, d.y);
        ctx.lineTo(d.x - 0.5, d.y + d.len);
        ctx.strokeStyle = `rgba(180, 220, 255, ${d.alpha})`;
        ctx.lineWidth = 1;
        ctx.stroke();
        d.y += d.speed;
        if (d.y > H + d.len) {
          d.y = -d.len;
          d.x = Math.random() * W;
        }
      });
      rafId = requestAnimationFrame(draw);
    };

    rafId = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(rafId);
      ctx.clearRect(0, 0, W, H);
    };
  }, [active]);

  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none absolute inset-0 h-full w-full transition-opacity duration-700"
      style={{ opacity: active ? 1 : 0 }}
    />
  );
}
